export default {
  clients: {
    addNewRow: false,
    statusGroup: 5,
    modelAllowedToMassage: 3,
    singleTableNameHe: 'לקוח',

    actionsLimit: {
      edit: false,
      view: 'all',
      remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'identical-number',
        editable: true
      },
      {
        validation: 'required',
        name: 'ins-type',
        // editable: true
      },
      {
        validation: 'required',
        name: 'ins-order',
        // editable: true
      },
      {
        validation: 'required',
        name: 'first-name',
        editable: true
      },
      {
        validation: 'required',
        name: 'last-name',
        editable: true
      },
      {
        validation: 'required',
        name: 'gender',
        editable: true
      },

      {
        validation: 'required',
        name: 'mobile-phone-number',
        type: 'tel',
        editable: true
      },
      {
        validation: 'required',
        name: 'additional-phone-number',
        type: 'tel',
        editable: true
      },
      {
        validation: 'required|email',
        name: 'email',
        type: 'email',
        editable: true
      },
      {
        validation: 'required',
        name: 'birthday-date',
        editable: true
      },
      {
        validation: 'required',
        name: 'ownership-date',
        editable: true
      },
      {
        validation: 'required',
        name: 'city',
        editable: true
      },
      {
        validation: 'required',
        name: 'street',
        editable: true
      },
      {
        validation: 'required',
        name: 'house-number',
        editable: true
      },
      {
        validation: 'required',
        name: 'apartment-number',
        editable: true
      },
      {
        name: 'use-another-address',
        editable: true
      },
      {
        name: 'city-another',
        editable: true
      },
      {
        name: 'street-another',
        editable: true
      },
      {
        name: 'house-number-another',
        editable: true
      },
      {
        name: 'apartment-number-another',
        editable: true
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        validation: 'required',
        name: 'policy-send',
        editable: true
      },
      {
        validation: 'required',
        name: 'license-number',
        editable: true
      },
      {
        validation: 'required',
        name: 'tac-1',
        editable: true
      },
      {
        type: 'textarea',
        name: 'comments',
        editable: true
      },
    ]
  },
  departments: {
    hideDateFilter: true,
    actionsLimit: {
      edit: 'admin',
      view: false,
      remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'name',
        editable: true
      },
    ]
  },
  renewals: {
    singleTableNameHe: 'חידוש',
    statusGroup: 7,
    modelAllowedToMassage: 4,

    //readonly: true
    actionsLimit: {
      edit: false,
      view: 'all',
      remove: 'all',
    },

    schema: [
      {
        name: 'firstName',
        editable: true
      },
      {
        name: 'lastName',
        editable: true
      },
      {
        name: 'tz',
        editable: true
      },
      {
        name: 'model',
        editable: true
      },
      {
        name: 'builtYear',
        editable: true
      },
      {
        name: 'policyNumber',
        editable: true
      },
      {
        name: 'company',
        editable: true
      },
      {
        name: 'event',
        editable: true,
      },
      {
        name: 'dateEnd',
        editable: true
      },
      {
        name: 'productType',
        editable: true
      },
      {
        name: 'premium',
        editable: true
      },
      {
        name: 'branchNumber',
        editable: true
      },
      {
        name: 'subBranch',
        editable: true
      },
      {
        name: 'custom',
        editable: true
      },
      /*  {
          type: 'date',
          name: 'followUp',
          editable: true
        },*/

      {
        name: 'messageRenew',
        editable: true,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true
      },
      {
        type: 'textarea',
        name: 'comments',
        editable: true
      },
    ]

  },
  leads: {
    tableName: 'leads',
    statusGroup: 4,
    modelAllowedToMassage: 2,
    singleTableNameHe: 'ליד',
    initDisplayCols: [
      'actions',
      'id',
      'subject',
      'fullName',
      'phone',
      'tz',
      'email',
      'insurance_select_period',
      'license_number',
      'content',
      'leadType',
      'source',
      'followUp',
      'statusId',
      'extra',
      'created_at',
    ],
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'all',
    },

    addNewRow: false,

    cfilters: {
      name: 'leadType',
      options: 'leadType'
    },

    schema: [
      {
        "name": "actions",
        "editable": false
      },
      {
        "name": "id",
        "editable": false
      }, {
        "name": "subject",
        "editable": true,
        "visible": false
      },
      {
        "name": "fullName",
        "editable": true,
        "visible": false
      },
      {
        "name": "phone",
        "editable": true
      },
      {
        "validation": "numeric|min:7",
        "name": "tz",
        "editable": true
      },
      {
        "name": "email",
        "editable": true
      },
      {
        "name": "insurance_select_period",
        "editable": true
      },
      {
        "name": "license_number",
        "editable": true
      },
      {
        "type": "textarea",
        "name": "content",
        "editable": true
      },
      {
        "validation": "required",
        "name": "leadType",
        "type": "text",
        "editable": true
      },
      {
        "validation": "required",
        "name": "source",
        "editable": true
      },
      {
        "type": "date",
        "name": "followUp",
        "editable": true
      },
      {
        "validation": "required",
        "name": "statusId",
        "type": "select",
        "options": "statuses",
        "editable": true
      },
      {
        "type": "textarea",
        "name": "extra",
        "editable": true
      },
      {
        "validation": "required",
        "name": "created_at",
        "type": "text",
        "editable": true
      }
    ]
  },
  calculator: {
    statusGroup: 13,
    modelAllowedToMassage: 5,
    singleTableNameHe: 'מחשבון',
    initDisplayCols: [
      'actions',
      'id',
      'statusName',
      'firstName',
      'lastName',
      'phone',
      'tz',
      'email',
      'created_at',
    ],
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'all',
    },

    addNewRow: false,

    cfilters: {
      name: 'calculatorType',
      options: 'calculatorType'
    },

    schema: [
      {
        "name": "actions",
        "editable": false
      },
      {
        "name": "id",
        "editable": false
      },
      {
        "validation": "required",
        "name": "statusId",
        "type": "select",
        "options": "statuses",
        "editable": true
      },
      {
        "name": "firstName",
        "editable": true,
        "visible": false
      },
      {
        "name": "lastName",
        "editable": true,
        "visible": false
      },
      {
        "name": "phone",
        "editable": true
      },
      {
        "validation": "numeric|min:7",
        "name": "tz",
        "editable": true
      },
      {
        "name": "email",
        "editable": true
      },

      {
        "type": "date",
        "name": "birthDate",
        "editable": true
      },
      {
        "type": "textarea",
        "name": "stepsInfo",
        "editable": true
      },
      {
        "validation": "required",
        "name": "created_at",
        "type": "text",
        "editable": true
      }
    ]
  },
  orders: {
    tableName: 'orders',
    statusGroup: 1,
    statusGroupName: 'orderStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'statusId',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
      'isRenewalOfExistingInsurance',
    ],

    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },

    schema: [

      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'select',
        editable: false,
      },

    ],

    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },

      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'text',
        editable: false,
      },
      {
        name: 'startDate',
        type: 'text',
        editable: true,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: true,
      },
      {
        name: 'price',
        type: 'text',
        editable: true,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },

      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      }
    ]
  },
  ordersControl: {
    statusGroup: 2,
    statusGroupName: 'lackOfClaimsStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'lackOfClaimsStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [

      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },

    ],
    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },

      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  ordersProtect: {
    statusGroup: 3,
    statusGroupName: 'protectiveStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'protectiveStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },
    ],
    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },
      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  ordersCancellations: {
    statusGroup: 10,
    statusGroupName: 'policyStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'policyStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },
    ],
    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },
      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  ordersCollection: {
    statusGroup: 9,
    statusGroupName: 'paymentStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'paymentStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },
    ],
    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },
      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  ordersTasks: {
    statusGroup: 11,
    statusGroupName: 'changesStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'changesStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'changesStatus',
        type: 'select',
        options: 'changesStatus',
        editable: false,
      },

      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },
    ],

    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },
      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  ordersClaims: {
    statusGroup: 12,
    statusGroupName: 'claimsStatus',
    modelAllowedToMassage: 1,
    initDisplayCols: [
      'actions',
      'id',
      'claimsStatus',
      'created_at',
      'insurance-date-start',
      'first-name',
      'last-name',
      'identical-number',
      'license-number',
      'hovaCompany',
      'secondCompany',
      'ins-type',
      'billingDate',
      'orderSource',
      'paymentKind',
      'createdFrom',
    ],
    addNewRow: false,
    actionsLimit: {
      edit: false,
      view: 'all',
      //remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'ins-type',
        type: 'select',
        options: [
          { key: '1', value: 'חובה' },
          { key: '2', value: 'מקיף' },
          { key: '3', value: 'צד ג' },
        ],
        editable: false,
      },
      {
        validation: 'required',
        name: 'protectiveStatus',
        type: 'select',
        options: 'protectionStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'lackOfClaimsStatus',
        type: 'select',
        options: 'lackOfClaims',
        editable: false,
      },
      {
        validation: 'required',
        name: 'paymentStatus',
        type: 'select',
        options: 'paymentStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'policyStatus',
        type: 'select',
        options: 'policyStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'claimsStatus',
        type: 'select',
        options: 'claimsStatus',
        editable: false,
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: false,
      },
      {
        validation: 'required',
        name: 'license-number',
        type: 'text',
        editable: true,
      },
    ],
    productsSchema: [
      {
        name: 'id',
        type: 'text',
        editable: false,
      },
      {
        name: 'orderId',
        type: 'text',
        editable: false,
      },
      {
        name: 'productName',
        type: 'text',
        editable: false,
      },
      {
        name: 'companyName',
        type: 'select',
        editable: false,
        options: [
          { key: '1', value: 'כלל' },
          { key: '2', value: 'מנורה' },
          { key: '3', value: 'שלמה' },
          { key: '4', value: 'סמי צריך לשלוח רשימה' },
        ],
      },
      {
        name: 'startDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'endDate',
        type: 'text',
        editable: false,
      },
      {
        name: 'price',
        type: 'text',
        editable: false,
      },
      {
        name: 'numberOfPayment',
        type: 'text',
        editable: true,
      },
      {
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        name: 'comments',
        type: 'textarea',
        editable: true,
      },
      {
        name: 'policyNumber',
        type: 'text',
        editable: true,
      },
      {
        name: 'deductible',
        type: 'text',
        editable: true,
      },
      {
        name: 'debtSettlement',
        type: 'text',
        editable: true,
      },
      {
        name: 'zadGimelRes',
        type: 'text',
        editable: true,
      },
      {
        name: 'description',
        type: 'text',
        editable: true,
      },
      {
        name: 'userName',
        type: 'text',
        editable: false,
      },
      {
        name: 'updated_at',
        type: 'text',
        editable: false,
      },
      {
        name: 'created_at',
        type: 'text',
        editable: false,
        view: ''
      },
    ]
  },
  policies: {
    readonly: true,
  },
  products: {
    readonly: true,
    statusGroup: 8,
  },
  statuses: {
    singleTableNameHe: 'סטטוס',

    actionsLimit: {
      edit: false,
      view: 'all',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'name',
        editable: true
      },
      /*{
        validation: 'required',
        name: 'model',
        editable: true
      },*/
      {
        //validation: 'required',
        type: 'color',
        name: 'color',
        editable: true
      },
      {
        validation: 'required',
        type: 'number',
        name: 'order',
        editable: true
      },
      {
        validation: 'required',
        type: 'multiselect',
        name: 'departmentId',
        options: 'departments',
        key: 'key',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'statusGroup',
        options: [
          { key: 1, value: 'סטטוס עסקה' },
          { key: 2, value: 'סטטוס העדר תביעות' },
          { key: 3, value: 'סטטוס מיגון' },
          { key: 4, value: 'לידים' },
          { key: 5, value: 'לקוחות' },
          { key: 6, value: 'משימות' },
          { key: 7, value: 'חידושים' },
          { key: 8, value: 'מוצרים' },
          { key: 9, value: 'גביה' },
          { key: 10, value: 'פוליסה' },
          { key: 11, value: 'שינויים' },
          { key: 12, value: 'תביעות' },
        ],
        editable: true
      },
      {
        name: 'group_id',
        type: 'multiselect',
        options: 'statuses_groups',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'isShowStatus',
        options: [
          { key: 0, value: 'לא' },
          { key: 1, value: 'כן' },
        ],
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'isAllowPaymentCompletion',
        options: [
          { key: 0, value: 'לא' },
          { key: 1, value: 'כן' },
        ],
        editable: true
      },
    ]
  },
  tasks: {
    statusGroup: 6,
    singleTableNameHe: 'משימה',

    actionsLimit: {
      edit: true,
      view: 'all',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'subject',
        editable: true
      },
      {
        validation: 'required',
        name: 'departmentId',
        type: 'select',
        options: 'departments',
        editable: true
      },
      {
        validation: 'required',
        name: 'description',
        editable: true
      },
      {
        //validation: 'required|numeric|min:7',
        validation: 'numeric|min:7',
        name: 'tz',
        editable: true
      },
      {
        //validation: 'required',
        name: 'customerName',
        editable: true
      },
      {
        //validation: 'required|numeric|min:7',
        validation: 'numeric|min:6',
        name: 'carNumber',
        editable: true
      },
      {
        //validation: 'required',
        name: 'employeeName',
        editable: true
      },
      {
        validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'statuses',
        editable: true,
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'content',
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'comments',
        editable: true
      },

    ]
  },
  users: {
    enableCsvUpload: true,
    singleTableNameHe: 'משתמש',

    actionsLimit: {
      edit: false,
      view: 'all',
      remove: 'admin',
    },

    cfilters: {
      name: 'departmentId',
      options: [
        { key: 1, value: 'Admin' },
        { key: 2, value: 'Management' },
        { key: 3, value: 'Agent' },
      ]
    },

    schema: [
      {
        validation: 'required',
        name: 'firstName',
        editable: true
      },
      {
        validation: 'required',
        name: 'lastName',
        editable: true
      },
      {
        validation: 'required',
        type: 'email',
        name: 'email',
        editable: true
      },
      {
        validation: 'required',
        type: 'tel',
        name: 'mobilePhone',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'departmentId',
        options: 'departments',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'modeSource',
        options: [
          { key: 'all', value: 'הכל' },
          { key: 'hova', value: 'hova' },
          { key: '10b', value: '10b' },
        ],
        editable: true
      },
      {
        validation: 'min:6|max:10|newUserPassword',
        name: 'password',
      },
      {
        name: 'dashboard_groups',
        type: 'multiselect',
        options: 'statuses_groups',
        editable: true
      },
      {
        name: 'dashboard_statuses',
        type: 'multiselect',
        options: 'statuses',
        editable: true
      },
    ]
  },
  messages: {
    singleTableNameHe: 'הודעה',
    actionsLimit: {
      edit: false,
      view: 'admin',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'displayName',
        editable: true
      },
      {
        validation: 'required',
        name: 'subject',
        editable: true
      },
      {
        // validation: 'required',
        name: 'address',
        editable: true
      },
      {
        // validation: 'required',
        name: 'smsPhoneNumber',
        editable: true
      },
      {
        // validation: 'required',
        type: 'select',
        name: 'autoSend',
        options: [
          { key: 0, value: 'ידני' },
          { key: 1, value: 'שליחת מייל - אוטומטית' },
          { key: 2, value: 'שליחת מייל והודעה - אוטומטית' },
          { key: 3, value: 'שליחת SMS בלבד' },
        ],
        editable: true
      },

      /*{
        validation: 'required',
        name: 'departmentAllowedToMassage',
        type: 'multiselect',
        options: 'departments',
        editable: true
      },*/
      {
        validation: 'required',
        name: 'modelAllowedToMassage',
        type: 'multiselect',
        // options: 'departments',
        options: [
          { key: 1, value: 'הזמנות' },
          { key: 2, value: 'לידים' },
          { key: 3, value: 'לקוחות' },
          { key: 4, value: 'חידושים' },
          { key: 5, value: 'מחשבון' },
        ],
        editable: true
      },

      {
        //validation: 'required',
        name: 'statusId',
        type: 'select',
        options: 'allStatuses',
        statusGroup: 'statusGroup',
        editable: true,
      },

      {
        //validation: 'required',
        type: 'text',
        name: 'replayTo',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'modeSource',
        options: [
          { key: 'all', value: 'הכל' },
          { key: 'hova', value: 'hova' },
          { key: '10b', value: '10b' },
        ],
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'content',
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'smsContent',
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'whatsappContent',
        editable: true
      },
      {
        name: 'isEditFile',
        type: 'checkbox',
        value: '0',
        editable: true
      },
      {
        name: 'isEmail',
        type: 'checkbox',
        value: '0',
        editable: true
      },
      {
        name: 'isSms',
        type: 'checkbox',
        value: '0',
        editable: true
      },
      {
        name: 'isWhatsapp',
        type: 'checkbox',
        value: '0',
        editable: true
      },
      {
        name: 'isEditable',
        type: 'checkbox',
        value: '0',
        editable: true
      },
      {
        name: 'isShowMessage',
        type: 'checkbox',
        value: '1',
        editable: true
      },


    ]
  },
  whatsappCampaign: {
    singleTableNameHe: 'הודעה',
    actionsLimit: {
      edit: false,
      view: 'admin',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'displayName',
        editable: true
      },
      {
        // validation: 'required',
        type: 'select',
        name: 'messageKind',
        options: [
          { key: 1, value: 'שירות לקוחות' },
          { key: 2, value: 'מכירות וחידושים' },
        ],
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'content',
        editable: true
      },
      {
        name: 'campaign_id',
        type: 'text',
        editable: false
      },
      {
        name: 'whatsappTemplateName',
        type: 'text',
        editable: false
      },
      {
        validation: 'required',
        type: 'select',
        name: 'modeSource',
        options: [
          { key: 'all', value: 'הכל' },
          { key: 'hova', value: 'hova' },
          { key: '10b', value: '10b' },
        ],
        editable: true
      },
      {
        name: 'isShowMessage',
        type: 'checkbox',
        value: '1',
        editable: true
      },
    ]
  },
  smsCampaign: {
    singleTableNameHe: 'הודעה',
    actionsLimit: {
      edit: false,
      view: 'admin',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'displayName',
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'content',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'modeSource',
        options: [
          { key: 'all', value: 'הכל' },
          { key: 'hova', value: 'hova' },
          { key: '10b', value: '10b' },
        ],
        editable: true
      },
      {
        name: 'isShowMessage',
        type: 'checkbox',
        value: '1',
        editable: true
      },
    ]
  },
  mailCampaign: {
    singleTableNameHe: 'הודעה',
    actionsLimit: {
      edit: false,
      view: 'admin',
      remove: 'admin',
    },

    schema: [
      {
        validation: 'required',
        name: 'displayName',
        editable: true
      },
      {
        validation: 'required',
        name: 'subject',
        editable: true
      },
      {
        //validation: 'required',
        type: 'textarea',
        name: 'content',
        editable: true
      },
      {
        validation: 'required',
        type: 'select',
        name: 'modeSource',
        options: [
          { key: 'all', value: 'הכל' },
          { key: 'hova', value: 'hova' },
          { key: '10b', value: '10b' },
        ],
        editable: true
      },
      {
        name: 'isShowMessage',
        type: 'checkbox',
        value: '1',
        editable: true
      },
    ]
  },
  phoneBook: {
    actionsLimit: {
      edit: 'admin',
      view: false,
      remove: 'admin',
    },
    schema: [
      {
        validation: 'required',
        name: 'fullName',
        editable: true
      }, {
        validation: 'required',
        name: 'phone',
        editable: true
      }, {
        validation: 'required',
        name: 'email',
        editable: true
      },
    ]
  }
}
